import { FC } from "react";
import ToggleColorInterconnection from "../../public/icons/Toggle_Color_Interconnection.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const ToggleColorInterconnectionIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><ToggleColorInterconnection/></span>;
